import { useScrollProgressBar } from "@design-system/hooks";

export function ScrollProgressBar() {
  const { scrolled } = useScrollProgressBar();

  return (
    <div className="fixed left-0 top-0 z-[120] h-[2px] w-full bg-transparent">
      <div
        className="transition-full shadow-progress-par h-full bg-bright-orange duration-100"
        style={{ width: `${scrolled}%` }}
      />
    </div>
  );
}
